export default {
  floatingTopMenu: {
    'openSettings': 'Beállítások',
    'showAbout': 'Általános információk megjelenítése',
    'about': 'Az ORS névjegye',
    'openrouteserviceAPI': 'Az Openrouteservice API',
    'openrouteserviceForDisasters': 'Az Openrouteservice katasztrófahelyzetekben',
    'askOpenrouteservice': 'Kérdezzen az Openrouteservice-től',
    'settingsTooltip': 'Kattintson ide, ha szeretne módosítani az alkalmazás beállításain és megtekinteni más opciókat is'
  }
}
